import React from "react";
import "./TyresSection.css";
import Tyre1 from "../assets/kcs.webp";
import Tyre2 from "../assets/DEA.webp";
import Tyre3 from "../assets/Ecu.webp";

const forensicsData = [
  {
    id: "01",
    title: "ECU Data Extraction",
    img: Tyre1,
    desc: "Professional extraction of critical data from Engine Control Units and vehicle modules. We recover hidden information, crash data, and system logs for forensic investigations and legal documentation."
  },
  {
    id: "02",
    title: "Vehicle System Scanning",
    img: Tyre2,
    desc: "Complete vehicle system scanning and fault detection services. We identify issues across all vehicle modules including engine, transmission, ABS, and electrical systems for comprehensive analysis."
  },
  {
    id: "03",
    title: "Court Testimony & Reports",
    img: Tyre3,
    desc: "Professional court testimony and comprehensive forensic reports for legal proceedings. Our certified experts provide clear, technical explanations and detailed documentation for insurance claims and litigation cases."
  }
];


function TyresSection() {
  return (
    <section className="tyres-section">
      <div className="tyres-grid">
        {forensicsData.map((service) => (
          <div className="tyre-card" key={service.id}>
            <div
              className="tyre-bg"
              style={{ backgroundImage: `url(${service.img})` }}
              loading="lazy"
            >
              <div className="tyre-overlay">
                <span className="tyre-number">{service.id}</span>
                <span className="tyre-brand">CAR FORENSICS</span>
                <span className="tyre-line"></span>
                <h3 className="tyre-title">{service.title}</h3>
              </div>
             <div className="tyre-info">
  <div className="tyre-info-content">
    <p>{service.desc}</p>
  </div>
</div>
            </div>
          </div>
        ))}
      </div>
    </section>
    
    
  );
}

export default TyresSection;